import Cookies from "js-cookie";
import { EPS_LANGUAGE_COOKIE } from "./setLanguageCookie";

const getLanguageCookie = () => Cookies.get(EPS_LANGUAGE_COOKIE);

export default getLanguageCookie;
